console.log("Entrypoint: application.js loaded");
import "./application.bootstrap.scss"
// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"

console.log('Vite ⚡️ Ruby')